import { z } from 'zod/v4';
// Shared filter schema for table view queries
export const TableViewFilterSchema = z.object({
    columnId: z.string(),
    // Text-based filters (text, verbatim columns) - multiple values use OR
    textValues: z.array(z.string()).nullish(),
    // Number filters - multiple values use OR, operator applies to all
    numberValues: z.array(z.number()).nullish(),
    numberOperator: z.enum(['eq', 'gt', 'gte', 'lt', 'lte']).nullish(),
    // Date filters (ISO string format) - multiple values use OR, operator applies to all
    dateValues: z.array(z.string()).nullish(),
    dateOperator: z.enum(['eq', 'gt', 'gte', 'lt', 'lte']).nullish(),
    // Options filter (match by option value) - multiple values use OR
    optionValues: z.array(z.string()).nullish(),
});
//# sourceMappingURL=table-view-filter.js.map